import { Guest } from '@adminModels';
import { createAction, props } from '@ngrx/store';

export const ADMIN_GUESTS_ID = '[Guests admin]';

export interface GuestsQueryParams {
  page?: number;
  limit?: number;
  search?: string;
  isActive?: boolean;
  sortBy?: 'name' | 'roleSk' | 'roleEn' | 'createdAt' | 'isActive';
  sortOrder?: 'ASC' | 'DESC';
}

export const loadGuests = createAction(
  ADMIN_GUESTS_ID + ' Load Guests',
  props<{ params?: GuestsQueryParams }>(),
);

export const loadGuestsSuccess = createAction(
  ADMIN_GUESTS_ID + ' Load Guests Success',
  props<{ guests: Guest[]; pagination: { total: number; page: number; limit: number; totalPages: number } }>(),
);

export const loadGuestsFailure = createAction(
  ADMIN_GUESTS_ID + ' Load Guests Failure',
  props<{ error: string }>(),
);

export const createGuest = createAction(
  ADMIN_GUESTS_ID + ' Create Guest',
  props<{ guestData: CreateGuestData }>(),
);

export const createGuestSuccess = createAction(
  ADMIN_GUESTS_ID + ' Create Guest Success',
  props<{ guest: Guest }>(),
);

export const createGuestFailure = createAction(
  ADMIN_GUESTS_ID + ' Create Guest Failure',
  props<{ error: string }>(),
);

export const updateGuest = createAction(
  ADMIN_GUESTS_ID + ' Update Guest',
  props<{ id: string; guestData: UpdateGuestData }>(),
);

export const updateGuestSuccess = createAction(
  ADMIN_GUESTS_ID + ' Update Guest Success',
  props<{ guest: Guest }>(),
);

export const updateGuestFailure = createAction(
  ADMIN_GUESTS_ID + ' Update Guest Failure',
  props<{ error: string }>(),
);

export const deleteGuest = createAction(
  ADMIN_GUESTS_ID + ' Delete Guest',
  props<{ id: string }>(),
);

export const deleteGuestSuccess = createAction(
  ADMIN_GUESTS_ID + ' Delete Guest Success',
  props<{ id: string }>(),
);

export const deleteGuestFailure = createAction(
  ADMIN_GUESTS_ID + ' Delete Guest Failure',
  props<{ error: string }>(),
);

export const uploadGuestPhoto = createAction(
  ADMIN_GUESTS_ID + ' Upload Guest Photo',
  props<{ id: string; file: File }>(),
);

export const uploadGuestPhotoSuccess = createAction(
  ADMIN_GUESTS_ID + ' Upload Guest Photo Success',
  props<{ guest: Guest }>(),
);

export const uploadGuestPhotoFailure = createAction(
  ADMIN_GUESTS_ID + ' Upload Guest Photo Failure',
  props<{ error: string }>(),
);

export const deleteGuestPhoto = createAction(
  ADMIN_GUESTS_ID + ' Delete Guest Photo',
  props<{ id: string }>(),
);

export const deleteGuestPhotoSuccess = createAction(
  ADMIN_GUESTS_ID + ' Delete Guest Photo Success',
  props<{ guest: Guest }>(),
);

export const deleteGuestPhotoFailure = createAction(
  ADMIN_GUESTS_ID + ' Delete Guest Photo Failure',
  props<{ error: string }>(),
);

export interface CreateGuestData {
  name: string;
  role: {
    sk: string;
    en: string;
  };
  description: {
    sk: string;
    en: string;
  };
  link?: string;
}

export interface UpdateGuestData {
  name?: string;
  role?: {
    sk: string;
    en: string;
  };
  description?: {
    sk: string;
    en: string;
  };
  link?: string;
}
